import script from "./GroupsFormMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupsFormMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./GroupsFormMolecule.css?vue&type=style&index=0&id=0da3db82&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da3db82"]])

export default __exports__